import { render, staticRenderFns } from "./lecturerDetails.vue?vue&type=template&id=54a93b0c&"
import script from "./lecturerDetails.vue?vue&type=script&lang=js&"
export * from "./lecturerDetails.vue?vue&type=script&lang=js&"
import style0 from "./lecturerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports